import { h } from 'preact';
import { useState } from 'preact/hooks';

export function CollapsibleEntry({ id, label, entries = [], open = false, remove }) {
  const [isOpen, setIsOpen] = useState(open);

  const toggle = (e) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  const handleRemove = (e) => {
    e.stopPropagation();
    if (remove) remove();
  };

  return (
    <div class={`epx-collapsible-entry${isOpen ? ' open' : ''}`} data-entry-id={id}>
      <div class="epx-collapsible-header" onClick={toggle}>
        <span class="epx-collapsible-arrow">{isOpen ? '\u25BE' : '\u25B8'}</span>
        <span class="epx-collapsible-label">{label}</span>
        {remove && (
          <button class="epx-btn-remove" onClick={handleRemove} title="Remove">&times;</button>
        )}
      </div>
      {isOpen && (
        <div class="epx-collapsible-body">
          {entries.map(entry => (
            <entry.component key={entry.id} />
          ))}
        </div>
      )}
    </div>
  );
}
